import { fetcher } from '@common/utils/fetcher';

export type PostProfileReportParams = {
  reported_user_id: string;
  reason: string;
  description?: string;
};

export type PostMatchReportParams = {
  matchId: string;
  reason: string;
  details?: string;
};

export type PostReportResponse = null;

export const postProfileReport = (params: PostProfileReportParams) => {
  return fetcher<PostReportResponse>({
    url: '/report',
    method: 'POST',
    data: params,
  });
};

export const postMatchReport = ({
  matchId,
  reason,
  details,
}: PostMatchReportParams) => {
  return fetcher<PostReportResponse>({
    url: `/matches/${matchId}/report`,
    method: 'POST',
    data: {
      reason,
      details,
    },
  });
};
